import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { PipelineAssetLocationDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-pipelineassetlocation-container',
  templateUrl: './pipelineassetlocation-container.component.html',
  styleUrls: ['./pipelineassetlocation-container.component.scss']
})
export class PipelineassetlocationContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  pipelineassetlocations$: Observable<PipelineAssetLocationDto[]>;
  loading: boolean;
  isLoadingPipelineAssetLocation$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingPipelineAssetLocation$ = this.gatwayFacade.isLoadingGateway("PipelineAssetLocation");
    this.pipelineassetlocations$ = this.gatwayFacade.loadGateway("PipelineAssetLocation");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeletePipelineAssetLocation(deletedValue: any) {
    this.gatwayFacade.remove("PipelineAssetLocation", deletedValue);
  }


// this method control both the create and update

  onSubmitPipelineAssetLocation(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.PipelineAssetLocations;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllPipelineAssetLocation = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllPipelineAssetLocation.push(pullData[i]);
    }
  }

// check if the addAllPipelineAssetLocation array is not empty, then dispatch the data to the store
   if(addAllPipelineAssetLocation.length > 0) {
    this.gatwayFacade.add('PipelineAssetLocation', addAllPipelineAssetLocation);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('PipelineAssetLocation', allUpdates, ['id']);
  }

   }


}
